import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BASE}/api`,
    headers: { "Content-Type": "application/json" },
    timeout: 60000,
});

export function apiErrorMessage(err) {
    const detail = err?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
    return err?.message || "Something went wrong.";
}
